
import Component from 'vue-class-component';
import Vue from 'vue';
import {settingStore} from '@/stores/index'
import HeaderLogo from './components/header/header-logo.vue'
import HeaderButton from './components/header/header-button.vue'
import HeaderMenu from './components/header/header-menu.vue'
import HeaderNotice from './components/header/header-notice.vue'
import HeaderUser from './components/header/header-user.vue'
import SiderMenu from './components/sider/index.vue'
import Tabs from './components/tabs/index.vue'
@Component({
    components:{HeaderLogo, HeaderButton, HeaderMenu, HeaderNotice , HeaderUser, SiderMenu, Tabs },
})
export default class BasicLayout extends Vue{
    store = settingStore();
    
}
